import { StyleSheet } from '@patternfly/react-styles';
export default StyleSheet.parse(`.pf-l-gallery{--pf-l-gallery--GridGap:var(--pf-global--gutter);--pf-l-gallery--GridTemplateColumns:repeat(auto-fill, minmax(250px, 1fr));display:grid;grid-template-columns:var(--pf-l-gallery--GridTemplateColumns);}.pf-l-gallery.pf-m-gutter{grid-gap:var(--pf-l-gallery--GridGap);}`);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/@patternfly/patternfly-next/layouts/Gallery/gallery.css.js
// module id = 290
// module chunks = 0